import React from 'react';
import { connect } from 'react-redux';

@connect(({ user }) => ({ profile: user.profile }))
export default class Intercom extends React.PureComponent {
  componentDidMount() {
    const { appId, profile } = this.props;

    const config = {
      app_id: `${appId}`,
      api_base: 'https://api-iam.intercom.io',
      ...(profile && {
        email: profile.email,
        user_id: `${profile.id}`,
      }),
    };

    if (window.Intercom) {
      window.Intercom('boot', config);
    }

    this.cleanUpIframeRolesWithObserver();
  }

  componentDidUpdate(prevProps) {
    const { appId, profile } = this.props;

    if (profile && prevProps.profile !== profile) {
      window.Intercom('update', {
        email: profile.email,
        user_id: `${profile.id}`,
      });
    }

    if (profile === undefined && prevProps.profile !== profile) {
      window.Intercom('shutdown');

      window.Intercom('boot', {
        app_id: `${appId}`,
        api_base: 'https://api-iam.intercom.io',
      });
    }
  }

  componentWillUnmount() {
    if (this._intercomObserver) {
      this._intercomObserver.disconnect();
    }
  }

  cleanUpIframeRolesWithObserver = () => {
    const observer = new MutationObserver(() => {
      const iframes = document.querySelectorAll('iframe[data-intercom-frame]');

      iframes.forEach((iframe) => {
        if (iframe.getAttribute('role') === 'dialog') {
          iframe.removeAttribute('role');
        }
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    this._intercomObserver = observer;
  };

  render() {
    const { appId } = this.props;

    return (
      <script
        dangerouslySetInnerHTML={{
          __html: `
          (function () {
            var w = window;
            var ic = w.Intercom;
            if (typeof ic === "function") {
              ic("reattach_activator");
              ic("update", w.intercomSettings);
            } else {
              var d = document;
              var i = function () {
                i.c(arguments);
              };
              i.q = [];
              i.c = function (args) {
                i.q.push(args);
              };
              w.Intercom = i;
              var l = function () {
                var s = d.createElement("script");
                s.type = "text/javascript";
                s.async = true;
                s.src = "https://widget.intercom.io/widget/${appId}";
                var x = d.getElementsByTagName("script")[0];
                x.parentNode.insertBefore(s, x);
              };
              if (document.readyState === "complete") {
                l();
              } else if (w.attachEvent) {
                w.attachEvent("onload", l);
              } else {
                w.addEventListener("load", l, false);
              }
            }
          })();
        `,
        }}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./components/html/thirdParty/Intercom.js